import FeedbackPage from '@/components/FeedbackPage'
import { getCompanionStyleFeedback } from '@/utils/feedbackContent'

export default function CompanionStyleFeedbackPage() {
  const content = getCompanionStyleFeedback()
  return <FeedbackPage {...content} />
}
